interface ProgressBarProps {
  value: number
  max: number
  showPercentage?: boolean
  label?: string
  colorClass?: string
}

export function ProgressBar({ 
  value, 
  max, 
  showPercentage = true, 
  label,
  colorClass = 'bg-emerald-600'
}: ProgressBarProps) {
  const percentage = max > 0 ? Math.min((value / max) * 100, 100) : 0
  
  const getColorClass = () => {
    if (percentage >= 90) return 'bg-red-600'
    if (percentage >= 75) return 'bg-amber-600'
    return colorClass
  }

  return (
    <div className="w-full">
      {(label || showPercentage) && (
        <div className="flex justify-between items-center mb-2">
          {label && <span className="text-sm text-slate-600">{label}</span>}
          {showPercentage && (
            <span className="text-sm font-medium text-slate-700">
              {percentage.toFixed(1)}%
            </span>
          )}
        </div>
      )}
      <div className="w-full bg-slate-200 rounded-full h-2.5 overflow-hidden">
        <div 
          className={`h-full rounded-full transition-all duration-300 ${getColorClass()}`}
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  )
}
